/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/impayes${buildQuery(params)}`, "GET"),

    getStats: async () => exeRequest(`/admin/impayes/stats`, "GET"),

    relanceSms: async (data) => exeRequest(`/admin/impayes/relance-sms`, "POST", data),
};
